import { alpha } from "@mui/material"
import { dsColorNew } from "@palette"

export default function useCellColors(isCheapestColumn, isMoreExpensiveColumn) {

	const borderColor = isCheapestColumn
		? alpha(dsColorNew.successBar, 0.55)
		: isMoreExpensiveColumn
			? dsColorNew.dangerBorder
			: dsColorNew.grayBorder

	const hoverBorderColor = isCheapestColumn
		? dsColorNew.successBar
		: isMoreExpensiveColumn
			? dsColorNew.dangerSoft
			: dsColorNew.appBlue

	const bgColor = isCheapestColumn
		? dsColorNew.successBg
		: isMoreExpensiveColumn
			? dsColorNew.dangerBg
			: dsColorNew.white


	return { bgColor, borderColor, hoverBorderColor }

}
